import React, { useState, useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import * as S from './style'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import { Header, Filter } from '../../../components/SubHeaderFilter/types'

export const collectionHeaders: Header[] = [
  { key: 'name', label: 'Coleção', type: 'string' },
  { key: 'brand', label: 'Marca', type: 'string' },
  { key: 'collectionColor', label: 'Cor', type: 'string' },
  { key: 'families', label: 'Família', type: 'string' },
  { key: 'grades', label: 'Grade', type: 'string' },
  { key: 'groups', label: 'Grupo', type: 'string' },
  { key: 'fabrics', label: 'Tecido', type: 'string' },
  { key: 'trimmings', label: 'Aviamento', type: 'string' },
  { key: 'episodes', label: 'Episódio', type: 'string' }
]

export interface CollectionsOutletType {
  refresh: number
  search: string
  Styled: typeof S
  isLoading?: boolean
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>
  appliedFilters: Filter[]
}

const Collections: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [refresh, setRefresh] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const context = useOutletContext<any>()
  const search = context?.search ?? ''
  const fallbackFiltersState = usePersistedFilters('collections')
  const collectionsFiltersState = context?.collectionsFiltersState || fallbackFiltersState

  const outletContext: CollectionsOutletType = {
    refresh,
    search,
    Styled: S,
    isLoading,
    setIsLoading,
    appliedFilters: collectionsFiltersState.appliedFilters
  }

  const isRegisterOrEdit =
    location.pathname.includes('/register') ||
    location.pathname.includes('/edit')

  useEffect(() => {
    const handleProductDevelopmentRefresh = (event: Event) => {
      const detail = (event as CustomEvent<{ tab?: string }>).detail
      if (detail?.tab === 'collection') {
        setRefresh((previous) => previous + 1)
      }
    }

    const handleProductDevelopmentCreate = (event: Event) => {
      const detail = (event as CustomEvent<{ tab?: string }>).detail
      if (detail?.tab === 'collection') {
        navigate('/panel/collection/register')
      }
    }

    window.addEventListener('product-development-refresh', handleProductDevelopmentRefresh as EventListener)
    window.addEventListener('product-development-create', handleProductDevelopmentCreate as EventListener)

    return () => {
      window.removeEventListener('product-development-refresh', handleProductDevelopmentRefresh as EventListener)
      window.removeEventListener('product-development-create', handleProductDevelopmentCreate as EventListener)
    }
  }, [navigate])

  if (isRegisterOrEdit) {
    return <Outlet context={outletContext} />
  }

  return (
    <S.Content>
      <Outlet context={outletContext} />
    </S.Content>
  )
}

export default Collections
